(() => {
  const moneyFormat = window.HON.moneyFormat || '${{amount}}';
  const routes = window.Shopify?.routes || { root: '/' };
  const selectors = {
    drawer: '[data-cart-drawer]',
    backdrop: '[data-cart-drawer-backdrop]',
    body: '[data-cart-drawer-body]',
    footer: '[data-cart-drawer-footer]',
    subtotal: '[data-cart-drawer-subtotal]',
    close: '[data-cart-drawer-close]'
  };

  let lastTrigger = null;
  let focusable = [];
  let previousScrollbarPadding = '';

  const formatMoney = (cents) => {
    const value = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };

  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  async function getCart() {
    const response = await fetch(`${routes.root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Could not load cart');
    return response.json();
  }

  async function changeLine(key, quantity) {
    const response = await fetch(`${routes.root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!response.ok) throw new Error('Could not update cart');
    return response.json();
  }

  function itemMarkup(item) {
    let fallbackImage = window.HON?.fallbackPack || '';
    const vtitle = String(item.variant_title || '').toLowerCase();
    if (window.HON?.pack250 && vtitle.includes('250')) fallbackImage = window.HON.pack250;
    if (window.HON?.pack500 && vtitle.includes('500')) fallbackImage = window.HON.pack500;
    if (window.HON?.pack1kg && (vtitle.includes('1kg') || vtitle.includes('1 kg') || vtitle.includes('1000'))) fallbackImage = window.HON.pack1kg;
    const imageUrl = fallbackImage || (item.image ? `${item.image}${item.image.includes('?') ? '&' : '?'}width=160` : '');
    const img = imageUrl ? `<img src="${imageUrl}" alt="${escapeHtml(item.product_title)}">` : '';
    const variant = item.variant_title ? `<div class="cart-line-variant">${escapeHtml(item.variant_title)}</div>` : '';
    const variantLower = String(item.variant_title || '').toLowerCase();
    let sizeNote = 'Creamy body, stone fruit, plum, dark chocolate and sweet jaggery finish.';
    if (variantLower.includes('250')) sizeNote = '250g tasting pack — ideal for first orders and gifting.';
    if (variantLower.includes('500')) sizeNote = '500g everyday home pack — balanced freshness and value.';
    if (variantLower.includes('1kg') || variantLower.includes('1 kg') || variantLower.includes('1000')) sizeNote = '1kg best-value pack — made for family, office and daily brewing.';
    return `
      <article class="drawer-line" data-cart-key="${item.key}">
        <a class="drawer-line-image" href="${item.url}">${img}</a>
        <div class="drawer-line-main">
          <a class="drawer-line-title" href="${item.url}">${escapeHtml(item.product_title)}</a>
          ${variant}
          <div class="drawer-line-note">Kavre, Nepal · 1,100–1,690m · Washed · Bourbon & Caturra<br>${escapeHtml(sizeNote)}</div>
          <div class="cart-qty">
            <button class="qty-btn" type="button" data-drawer-minus aria-label="Decrease quantity">−</button>
            <input class="qty-input" type="number" min="0" value="${item.quantity}" data-drawer-qty aria-label="Quantity">
            <button class="qty-btn" type="button" data-drawer-plus aria-label="Increase quantity">+</button>
          </div>
          <button class="cart-remove" type="button" data-drawer-remove>Remove</button>
        </div>
        <div class="cart-line-price">${formatMoney(item.final_line_price)}</div>
      </article>
    `;
  }

  function escapeHtml(string) {
    return String(string || '').replace(/[&<>"']/g, (s) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[s]));
  }

  function renderCart(cart) {
    const drawer = qs(selectors.drawer);
    const body = qs(selectors.body);
    const footer = qs(selectors.footer);
    const subtotal = qs(selectors.subtotal);
    if (!drawer || !body) return;

    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
    document.querySelectorAll('[data-cart-link]').forEach((el) => { el.classList.toggle('is-empty', cart.item_count === 0); });

    if (!cart.items.length) {
      body.innerHTML = `<div class="cart-drawer-empty"><p>Your cart is resting. Add Roasted Coffee from Nepal when you are ready.</p><a class="btn btn-primary" href="/products/nepal-roasted-coffee">Shop coffee</a></div>`;
      if (footer) footer.hidden = true;
    } else {
      body.innerHTML = cart.items.map(itemMarkup).join('');
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
      if (footer) footer.hidden = false;
    }
  }

  async function refreshCart() {
    const cart = await getCart();
    renderCart(cart);
    return cart;
  }

  function setBodyLock(lock) {
    if (lock) {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      previousScrollbarPadding = document.body.style.paddingRight;
      document.body.style.paddingRight = scrollbarWidth ? `${scrollbarWidth}px` : previousScrollbarPadding;
      document.body.classList.add('cart-drawer-open');
    } else {
      document.body.classList.remove('cart-drawer-open');
      document.body.style.paddingRight = previousScrollbarPadding;
    }
  }

  function trapFocus(event) {
    const drawer = qs(selectors.drawer);
    if (!drawer || event.key !== 'Tab') return;
    focusable = qsa('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', drawer);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function openDrawer(trigger) {
    const drawer = qs(selectors.drawer);
    const backdrop = qs(selectors.backdrop);
    if (!drawer || !backdrop) return;
    lastTrigger = trigger || document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    backdrop.classList.add('is-open');
    setBodyLock(true);
    requestAnimationFrame(() => {
      const close = qs(selectors.close, drawer);
      (close || drawer).focus();
    });
    document.addEventListener('keydown', onKeydown);
    document.addEventListener('keydown', trapFocus);
  }

  function closeDrawer() {
    const drawer = qs(selectors.drawer);
    const backdrop = qs(selectors.backdrop);
    if (!drawer || !backdrop) return;
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    setBodyLock(false);
    document.removeEventListener('keydown', onKeydown);
    document.removeEventListener('keydown', trapFocus);
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
  }

  function onKeydown(event) {
    if (event.key === 'Escape') closeDrawer();
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('form[action*="/cart/add"]')) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    if (button) {
      button.disabled = true;
      button.dataset.originalText = button.textContent;
      button.textContent = 'Adding';
    }
    try {
      const response = await fetch(`${routes.root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) throw new Error('Add failed');
      await refreshCart();
      openDrawer(button || form);
    } catch (error) {
      if (button) button.textContent = 'Try again';
      console.error(error);
    } finally {
      if (button) {
        setTimeout(() => {
          button.disabled = false;
          button.textContent = button.dataset.originalText || 'Add to cart';
        }, 900);
      }
    }
  });

  document.addEventListener('click', async (event) => {
    const cartTrigger = event.target.closest('[data-cart-trigger]');
    if (cartTrigger) {
      event.preventDefault();
      try { await refreshCart(); } catch (error) { console.error(error); }
      openDrawer(cartTrigger);
      return;
    }
    if (event.target.closest(selectors.close) || event.target.matches(selectors.backdrop)) closeDrawer();

    const line = event.target.closest('[data-cart-key]');
    if (!line) return;
    const input = line.querySelector('[data-drawer-qty]');
    const key = line.getAttribute('data-cart-key');
    const current = Number(input?.value || 0);
    let next = current;

    if (event.target.matches('[data-drawer-plus]')) next = current + 1;
    if (event.target.matches('[data-drawer-minus]')) next = Math.max(0, current - 1);
    if (event.target.matches('[data-drawer-remove]')) next = 0;
    if (next === current && !event.target.matches('[data-drawer-remove]')) return;

    const oldValue = current;
    if (input) input.value = next;
    try {
      const cart = await changeLine(key, next);
      renderCart(cart);
    } catch (error) {
      if (input) input.value = oldValue;
      console.error(error);
    }
  });

  document.addEventListener('change', async (event) => {
    if (!event.target.matches('[data-drawer-qty]')) return;
    const line = event.target.closest('[data-cart-key]');
    if (!line) return;
    const key = line.getAttribute('data-cart-key');
    const oldValue = Number(event.target.defaultValue || 0);
    const next = Math.max(0, Number(event.target.value || 0));
    try {
      const cart = await changeLine(key, next);
      renderCart(cart);
    } catch (error) {
      event.target.value = oldValue;
      console.error(error);
    }
  });

  document.addEventListener('DOMContentLoaded', refreshCart);
  window.HONCart = { open: openDrawer, close: closeDrawer, refresh: refreshCart, formatMoney };
})();
